import * as React from "react"
import * as Theme from "./theme"

type ClassNames = {
	heading: string
	group: string
	item: string
	label: string
	content: string
}

const getClasses = (c: Theme.ThemeContext): ClassNames => c.theme && c.theme == "frontend" ? classNames.frontend : classNames.admin
const classNames = {
	frontend: {
		heading: 'sbFieldGroupHeading',
		group: 'sbFieldGroup',
		item: 'sbFieldLi',
		label: 'sbFieldLabel',
		content: 'sbFieldContent',
	},
	admin: {
		heading: 'sbFieldGroupHeading sbRoundedEdges',
		group: 'sbFieldGroupFieldset sbRoundedEdges',
		item: 'sbFormItem clearfix',
		label: 'sbFormItemLabel',
		content: 'sbFormItemContent',
	}
}

export interface GroupProps {
	isVisible?: boolean
	width?: string
	height?: string
	heading?: string
	children?: React.ReactNode
}

export class Group extends React.Component<GroupProps, {}> {
	context: Theme.ThemeContext | undefined

	static contextTypes = {
		theme: React.PropTypes.string
	}

	render() {
		const style:React.CSSProperties = {
			width:   this.props.width ? this.props.width : undefined,
			height:  this.props.height ? this.props.height : undefined,
			display: this.props.isVisible ? "none" : undefined
		}

		const classes = getClasses(this.context || {})

		const heading = this.props.heading
			? <div className={classes.heading}>{this.props.heading}</div>
			: null

		return <fieldset className={classes.group} style={style}>
			{heading}
			<ol className="sbFieldGroupOl">{this.props.children}</ol>
		</fieldset>
	}
}

export interface ItemProps {
	label?: string
	isRequired?: boolean
	id?: string
	children?: React.ReactNode
}

export class Item extends React.Component<ItemProps, {}> {
	context: Theme.ThemeContext = {}

	static contextTypes = {
		theme: React.PropTypes.string
	}

	render() {
		const classes = getClasses(this.context)
		const label = this.props.label
			? <label className={classes.label} htmlFor={this.props.id}>
				{this.props.isRequired ? "*\u00a0" : ""}
				{this.props.label}
			</label>
			: null;

		return <li className={classes.item}>
			{label}
			<div className={classes.content}>
				{this.props.children}
			</div>
		</li>
	}
}




// WEBPACK FOOTER //
// ./src/lib/sbhtml/field.tsx